import { Grid } from "@mui/material";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
import { useLocation } from "react-router";
import OperationalReport from "./OperationalReport";
import { useEffect, useState } from "react";
import { FnAxios, FnDialog } from "utilities/utilities";

const ReportList = () => {
    const AxiosFn = FnAxios();
    const [arrMode, setMode] = useState([]);

    const getFormInitial = () => {
        AxiosFn.Post(`OperationalReport/GetFormInitialReport`, {}, (result) => {
            setMode(result.objResult.lstMode);
        });
    }

    useEffect(() => {
        getFormInitial();
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item marginTop={"10px"} xs={12}>
                <Tabs id={"ReportList"} defaultTab={"4"}>
                    <TabItem id="4">{"ข้าราชการ"}</TabItem>
                    <TabItem id="5">{"ลูกจ้างประจำ"}</TabItem>
                    <TabItem id="6">{"พนักงานราชการ"}</TabItem>
                    <TabItem id="7">{"พนักงานจ้างเหมาบริการ"}</TabItem>
                    <TabItem id="102">{"พนักงานกองทุน"}</TabItem>
                    <TabContent id={"ReportListTabContent"}>
                        <TabPanel id="4" >
                            <OperationalReport sMode="4" />
                        </TabPanel>
                        <TabPanel id="5">
                            <OperationalReport sMode="5" />
                        </TabPanel>
                        <TabPanel id="6">
                            <OperationalReport sMode="6" />
                        </TabPanel>
                        <TabPanel id="7" >
                            <OperationalReport sMode="7" />
                        </TabPanel>
                        <TabPanel id="102">
                            <OperationalReport sMode="102" />
                        </TabPanel>
                    </TabContent>
                </Tabs>
            </Grid>
        </Grid>
    );
}

export default ReportList;